import React from "react";
import Lottie from "lottie-react";
import Button from "../DesignSystem/Button";
import { PrimaryHeading } from "../styles";
import { ContactContainer } from "./styles";

const Contact = () => {
  const Lottie1 = require("../../assets/lottie/location-map.json");
  const Lottie2 = require("../../assets/lottie/mail-read.json");
  const Lottie3 = require("../../assets/lottie/contacts.json");

  return (
    <ContactContainer className="contact-page bg-black">
      <div className="container contact-shell animate__animated animate__fadeInUp">
        <div className="row g-4 align-items-stretch">
          <div className="col-12 col-lg-5">
            <div className="contact-intro glass-card h-100">
              <p className="eyebrow mb-2">Get in touch</p>
              <PrimaryHeading className="display-4 mb-3">
                Connect with me!
              </PrimaryHeading>
              <p className="intro-copy mb-4">
                With a proven track record of delivering high-quality AR
                applications that delight users, I&apos;m excited to continue
                pushing the boundaries of augmented reality, creating immersive
                and memorable experiences that captivate audiences and enhance
                user engagement.
              </p>

              <div className="contact-cards row g-3">
                <div className="col-12 contact-card animate__animated animate__fadeInLeft">
                  <div className="icon-shell">
                    <Lottie animationData={Lottie1} loop style={{ height: 68 }} />
                  </div>
                  <div>
                    <h4>Visit My Place</h4>
                    <p>Hochschule Ravensburg-Weingarten</p>
                    <p>Mon - Fri (10AM - 7PM)</p>
                  </div>
                </div>

                <div className="col-12 contact-card animate__animated animate__fadeInUp">
                  <div className="icon-shell">
                    <Lottie animationData={Lottie2} loop style={{ height: 68 }} />
                  </div>
                  <div>
                    <h4>Email Me</h4>
                    <p>bharath09vadde@gmail.com</p>
                    <p>Weingarten, Baden Wurttemberg</p>
                  </div>
                </div>

                <div className="col-12 contact-card animate__animated animate__fadeInRight">
                  <div className="icon-shell">
                    <Lottie animationData={Lottie3} loop style={{ height: 68 }} />
                  </div>
                  <div>
                    <h4>Connect With Me</h4>
                    <p>Mobile: +1 764-716-1890</p>
                    <p>Fax: +1 764-716-1890</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 col-lg-7">
            <div className="contact-form-wrap glass-card h-100 animate__animated animate__fadeInUp">
              <h3 className="form-title mb-4">Send a Message</h3>
              <form>
                <input
                  type="hidden"
                  name="_token"
                  defaultValue="qbb1gapMo8EZg9Dc1qKCNarwH28RoXajgNx0xmz9"
                />

                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label">
                      First name<sup className="text-danger ms-1">*</sup>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="first_name"
                      id="first_name"
                      placeholder="Enter First Name"
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">Last name</label>
                    <input
                      className="form-control"
                      type="text"
                      name="last_name"
                      id="last_name"
                      placeholder="Enter Last Name"
                    />
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label">
                    Email address<sup className="text-danger ms-1">*</sup>
                  </label>
                  <input
                    className="form-control"
                    type="email"
                    name="email"
                    id="email"
                    placeholder="name@example.com"
                  />
                </div>

                <div className="mb-4">
                  <label className="form-label">
                    Message<sup className="text-danger ms-1">*</sup>
                  </label>
                  <textarea
                    className="form-control"
                    name="message"
                    id="cont-message"
                    placeholder="Write a message"
                  />
                </div>

                <div className="text-center text-md-start">
                  <Button className="contact-submit" type="submit" isHideIcon>
                    <span>Send Message</span>
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </ContactContainer>
  );
};

export default Contact;
